<div>
  <h1 mat-dialog-title>{{ 'FRONTEND.SALES_UI.SELECT_SALESPERSON' | translate }}</h1>
  <mat-dialog-content>
    <ng-container *ngIf="salespersonOptions$$ | async as salespersonOptions">
      <EXP__glxy-wrap>
        <mat-form-field style="width: 100%">
          <mat-label>{{ 'FRONTEND.SALES_UI.SELECT_SALESPERSON' | translate }}</mat-label>
          <mat-chip-grid #chipList>
            <mat-chip-row *ngIf="!!selectedSalesperson" (removed)="unselectSalesperson()">
              {{ selectedSalesperson?.firstName }} {{ selectedSalesperson?.lastName }}
              <button matChipRemove><mat-icon>cancel</mat-icon></button>
            </mat-chip-row>
            <input
              #chipInput
              [formControl]="searchCtrl"
              [matChipInputFor]="chipList"
              [matAutocomplete]="autocomplete"
            />
            <glxy-loading-spinner
              *ngIf="loading"
              [size]="'default'"
              [fullWidth]="false"
              [fullHeight]="false"
              [inline]="true"
            ></glxy-loading-spinner>
          </mat-chip-grid>
          <mat-autocomplete #autocomplete (optionSelected)="selectSalesperson($event)">
            <mat-option *ngFor="let user of salespersonOptions" [value]="user">
              <div>{{ user?.firstName }} {{ user?.lastName }}</div>
            </mat-option>
            <glxy-infinite-scroll-trigger
              [visiblilityMargin]="120"
              (isVisible)="loadMore()"
            ></glxy-infinite-scroll-trigger>
          </mat-autocomplete>
          <mat-hint>{{ 'FRONTEND.SALES_UI.MAX_ONE_SALESPERSON' | translate }}</mat-hint>
        </mat-form-field>
      </EXP__glxy-wrap>
    </ng-container>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button matDialogClose tabindex="-1">
      {{ 'FRONTEND.SALES_UI.CANCEL' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="select()">
      {{ 'FRONTEND.SALES_UI.SELECT' | translate }}
    </button>
  </mat-dialog-actions>
</div>
